export default {
  loading: false,
  mgmt_accounts: [],
  mgmt_account: {},
  totalCount: 0,
};
